import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('loanIndustryPurposeCache', (http, CacheFactory, config) =>
  new LocalCache({
      provider: () => http.get(`/products/loans/loan-purposes-to-industry`),
      cacheFactory: CacheFactory,
      cacheTime: config.cache.loanPurposesToIndustry,
      cacheName: `loanPurposesToIndustry`
    }
  )
);
